import {useSelector} from 'react-redux';

import {selectExperienceScore} from '@/state/selectors/inference';

const MAX_PERCENTAGE = 100;

/** The score arrives on whatever scale the model uses, so the UI works with its share of max_score. */
const getScorePercentage = (score = 0, maxScore = 0) =>
    maxScore > 0 ? Math.round((score / maxScore) * MAX_PERCENTAGE) : 0;

const useScoreData = () => {
    const scoreData = useSelector(selectExperienceScore);

    return {
        status: scoreData?.status,
        scorePercentage: getScorePercentage(scoreData?.score, scoreData?.max_score),
    };
};

export default useScoreData;
